import React from 'react';
import styled from 'styled-components';
import { respondTo } from '../../util/breakpoints';
import * as colors from '../../util/colors';
import { FootnoteStyle} from '../../util/typography';

const TextIcon1ColumnContent = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: ${({ effHypoPatientStyle }) => (effHypoPatientStyle ? '20px' : '15px')};
    flex: 1 0 0;
    img {
        width: ${({ effHypoPatientStyle }) => (effHypoPatientStyle ? '100%' : '50px')};
        height: ${({ effHypoPatientStyle }) => (effHypoPatientStyle ? 'unset' : '50px')};
        margin-left: ${({ effHypoPatientStyle }) => (effHypoPatientStyle ? 'unset' : '-7px')};
    }
    ${respondTo.md`
        flex-direction: row;   
        gap: ${({ effHypoPatientStyle }) => (effHypoPatientStyle && '50px')};     
        img {
            margin-left: 0;
            width: ${({ effHypoPatientStyle }) => (effHypoPatientStyle ? 'unset' : '50px')};
        }
    `}
`;

const Column = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    flex: 1 0 0;
    color: ${colors.charcoal};
    height: 100%;
    justify-content: ${({ effHypoPatientStyle }) => (effHypoPatientStyle ? 'flex-start' : 'center')};
    li::marker, li::before {
        background-color: ${({type}) => type === 'keytruda' ? colors.greenDark : type === 'lenvima' ? colors.mulberry : colors.charcoal};
    }
`;

const Title = styled.div`
    color: ${({type}) => type === 'keytruda' ? colors.greenDark : type === 'lenvima' ? colors.mulberry : colors.charcoal};
`;

const ReferenceHypo =  styled.div`
    ${FootnoteStyle};
    margin-top: 10px;
`

const HypotheticSection =  styled.div`
    width: 100%;
    line-height: 0;

    ${respondTo.md`
        width: unset;   
    `}
`;
const CellTypeWrapper = styled.div`
margin-top: 10px;
font-size: 16px;
font-weight: 700;
line-height: 20px; 
`;
const TextIcon1Column = ({children, className, imgSrc, imgAlt = '', type, noTitle, titleType, effHypoPatientStyle, cellType}) => {
    return (
        <TextIcon1ColumnContent className={className} effHypoPatientStyle={effHypoPatientStyle}>
            {
                effHypoPatientStyle ? <HypotheticSection>{imgSrc && <img src={imgSrc} alt={imgAlt}/>} {cellType && <CellTypeWrapper>{cellType}</CellTypeWrapper>}  <ReferenceHypo>Hypothetical Patient</ReferenceHypo> </HypotheticSection> : imgSrc && <img src={imgSrc} alt={imgAlt}/>
            }  

            <Column type={type} effHypoPatientStyle={effHypoPatientStyle}>
                {!noTitle && <Title type={titleType || type}>{Array.isArray(children) ? children[0] : children}</Title>}
                {noTitle ? children : children[1] && children.slice(1)}
            </Column>
        </TextIcon1ColumnContent>
)};
export default TextIcon1Column;
 